import { Component } from "react";
import _ from 'lodash';
import { ITrackUpdates } from '@ModelViews/ModelViews';
import { StateManager } from '@Utils/StateManager';
import { isDefined, IsNullOrWhiteSpace } from '@Utils/Micro';
import { WebNode } from '@API/WebNode';
import { ReduxThingState } from '@API/WebNodeTypes';
import { Formatters } from '@Utils/Formats';
// ------------------------------------------------------------------------------------------------
export interface LastUpdateTsPrimitiveProps {
    NodeKey: string;
    ThingKey: string;
    Settings: ITrackUpdates;
}
export class LastUpdateTsPrimitive extends Component<LastUpdateTsPrimitiveProps, {}> {
    version = 0;
    constructor(props: Readonly<LastUpdateTsPrimitiveProps>) {
        super(props);

        let stateManager = StateManager.GetInstanceKey(this.props.NodeKey);
        if (isDefined(stateManager)) {
            stateManager.RegisterCB(this.props.ThingKey, this.stateUpdate);
            let stateThing = stateManager.GetState(this.props.ThingKey);
            this.version = stateThing?.Version;
        }
    }
    // ------------------------------------------------------------------------------------------------
    stateUpdate = (state: ReduxThingState, forceUpdate: boolean) => {
        if (this.version != state.Version || forceUpdate)
            this.forceUpdate();
    }
    // ------------------------------------------------------------------------------------------------
    componentWillUnmount() {
        let stateManager = StateManager.GetInstanceKey(this.props.NodeKey);
        if (isDefined(stateManager))
            stateManager.UnRegisterCB(this.props.ThingKey, this.stateUpdate);
    }
    // ------------------------------------------------------------------------------------------------
    render() {
        let lastUpdateTs: string;
        if (this.props.Settings.IsExplicit ||
            _.isString(this.props.Settings.Timestamp)) {
            // Use the provided timestamp.
            lastUpdateTs = this.props.Settings.Timestamp;
        } else {
            // Get node.
            const node = WebNode.GetInstanceKey(this.props.NodeKey);
            if (!isDefined(node))
                return null;

            // Get thing.
            const thing = node.DBGMsgsRoot.Things[this.props.ThingKey];
            if (isDefined(thing)) {
                // Collect all timestamps.
                let timestamps = [];
                _.forEach(thing.Ports, port =>
                    _.forEach(port.States, state =>
                        timestamps.push(state.Timestamp)));

                // Get the most recent.
                if (timestamps.length > 0) {
                    timestamps.sort();
                    lastUpdateTs = _.last(timestamps);
                }
            }
        }

        if (IsNullOrWhiteSpace(lastUpdateTs))
            return null;

        // Get formatted timestamp
        return Formatters.datetime(
            lastUpdateTs,
            this.props.Settings.DateFormat
        );
    }
}
// ------------------------------------------------------------------------------------------------